// import 'slick-carousel';
// import $ from 'jquery';
// import scrollLock from 'scroll-lock'
// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
// import { Observer } from "gsap/Observer";
// import { CustomEase } from "gsap/CustomEase";

// gsap.registerPlugin(ScrollTrigger,ScrollToPlugin,CustomEase,Observer);

const is_Mobile = window.matchMedia('(max-width: 700px)').matches;
ScrollTrigger.refresh();

var animating = false;
const down = -1;
const up = 1;

let topLoc = "0";
let midLoc = "0";
let botLoc = "0";
let startBotLoc = "0";
let startTopLoc = "0";
let slide_item_height = "0";

if (is_Mobile) {
  topLoc = "-61vh";
  midLoc = "0vh";
  botLoc = "100vh";
  startBotLoc = "130vh";
  startTopLoc = "-115vh";
  slide_item_height = "100vh";
} else {
  topLoc = "-61vh";
  midLoc = "9vh";
  botLoc = "80vh";
  startBotLoc = "130vh";
  startTopLoc = "-115vh";
  slide_item_height = "80vh";
}

var currentIndex = 0;
var prev = 0;
var next = 0;
const sections = document.querySelectorAll(".paragraph--type--timeline-item");
const center_img = gsap.utils.toArray(".paragraph--type--timeline-item .center-image img");
const titles = gsap.utils.toArray(".paragraph--type--timeline-item .slide-down-holder");
const contents = gsap.utils.toArray(".paragraph--type--timeline-item .content-value");
if ($(".our-story").length) {
  // $(".bg-image").hide();
  $(".bg-image").appendTo(".background_drop");
  const bgs = gsap.utils.toArray(".bg-image");
  $(".paragraph--type--timeline-item").css('height', slide_item_height).hide();
  $(bgs[0]).addClass('show');
  // $(sections[0]).show();
  // $(".timeline-ul").css('background-image', 'url(' + $(center_img[0]).attr('src') + ')');
  resetTimeline();
  var observer = Observer.create({
    // target: ".paragraph--type--timeline-item",
    ignore: [".our-story-double", ".hero_center", ".paragraph--type--simple-section"],
    type: "wheel,touch,pointer",
    wheelSpeed: -1,
    onDown: () => {
      console.log("Entering down ", currentIndex, currentIndex - 1, animating, (!animating &&  gotoSection(currentIndex - 1, down)) );
      !animating && gotoSection(currentIndex - 1, down);
    },
    onUp: () => {
      console.log("Entering up ", currentIndex, currentIndex + 1, up);
      !animating && gotoSection(currentIndex + 1, up);
    },
    onUpdate: () => {
      console.log(animating);
    },
    tolerance: 40,
    preventDefault: true,
  });
  
  
  observer.disable();
  if ($(".timeline-ul").length) {
    ScrollTrigger.create({
        trigger: ".timeline-ul",
        start: "center-=100 bottom",
        end: "bottom-=5 top",
        // markers: true,
        onEnter: () =>  {
          resetTimeline();
          scrollToTimeline();
          // initializeTimeline();
          gotoSection(0, up);
        },
        onEnterBack: () => {
          scrollToTimeline();
        },
        onLeaveBack: () => {
          observer.disable();
          resetTimeline();
        },
        onLeave: () => {
          animating = false;
          observer.disable();
        }
    });
  }
  function scrollToTimeline()
  {
    animating = true;
    console.log("Animating scrolltotimeline ", animating);
    gsap.to(window, {
      scrollTo: {y: ".timeline-ul", autoKill: false},
      duration: 1,
      ease: CustomEase.create("custom", "M0,0 C0,0 0.098,0.496 0.18,0.694 0.277,0.929 0.504,1 1,1 "),
      onComplete: () => {
        animating = false;
      }
    });
    observer.enable();
  }
  
  function resetTimeline()
  {
    currentIndex = 0;
    prev = 0;
    next = 0;
    
    sections
    sections.forEach(function(item) {
      
    });
    var resetTimeline = gsap.timeline();
    $(sections).each(function( index, element ) {
      resetTimeline.set(sections[index], { y: startBotLoc });
      resetTimeline.set(titles[index], { autoAlpha: 0 })
      resetTimeline.set(contents[index], { autoAlpha: 0 })
      $(sections[index]).hide();
    });
    $(".bg-image").removeClass("show");
    $(sections[0]).show();
  }
  
  function moveToLastSection()
  {
      animating = true;
      console.log("Animating moveToLastSection ", animating);
      gsap.to(window, {
        scrollTo: {y: ".scrolltrigger", autoKill: false},
        duration: 1,
        ease: CustomEase.create("custom", "M0,0 C0,0 0.098,0.496 0.18,0.694 0.277,0.929 0.504,1 1,1 "),
        onComplete: () => {
          animating = false;
          console.log("DONE move to last ", animating);
        }
      });
      observer.disable();
  }
  
  function gotoSection(index, direction) {
      
      if (index < 0) { 
        observer.disable();
        return false;
      }
    
      if (index > sections.length - 1) {
        moveToLastSection();
        return false;  
      }
      
      animating = true;
      
      currentIndex = index;
      let tl = gsap.timeline({
        defaults: {duration: 0.7, ease: "power1.inOut"},
        // onComplete: () => animating = false,
        // stagger: 0.5,
      });
      
      if (direction == up) {
        moveUp(currentIndex, tl);
      } else if (direction == down) {
        moveDown(currentIndex, tl);
      }
  }
  
  function moveDown(index, tl)
  {
    
      if (index + 2 <= sections.length) {
        tl.fromTo(sections[index + 2], { y: botLoc }, { y: startBotLoc }, 0.5);
      }
      
      if (index + 1 <= sections.length) {
        next = index + 1;
        tl.to(titles[next], { autoAlpha: 0, duration: 0.3 }, 0)
        tl.to(contents[next], { autoAlpha: 0, duration: 0.3 }, 0)
        tl.to(sections[next], { y: botLoc }, 0.5);
        tl.fromTo(center_img[next], { scale: 1 }, { scale: 0.7 }, 0.5);
        $(bgs[next]).removeClass('show');
      }
      
      tl.to(sections[index], { y: midLoc }, 0.5);
      tl.fromTo(center_img[index], { scale: 0.7 }, { scale: 1 }, 0.5);
      tl.to(titles[index], { autoAlpha: 1, duration: 0.5 }, 1)
      tl.to(contents[index], { autoAlpha: 1, duration: 0.5, onComplete: () =>  { animating = false} }, 1)
      $(bgs[index]).addClass('show');
      
      if (index - 1 >= 0) {
        prev = index - 1;
        $(sections[prev]).show();
        tl.fromTo(sections[prev], { y: startTopLoc }, { y: topLoc }, 0.5);
        tl.fromTo(center_img[prev], { scale: 0.7 }, { scale: 0.7 }, 0.5);
        tl.set(titles[prev], { autoAlpha: 0})
        tl.set(contents[prev], { autoAlpha: 0 })
      }
  }
  
  
  function moveUp(index, tl)
  {
      if (index - 2 >= 0) {
        tl.to(sections[index - 2], { y: startTopLoc, onComplete: () => {
          $(sections[index - 2]).hide();  
        }}, 0.5);
        
      }
      if (index > 0) {
        prev = index - 1;
        $(sections[prev]).show();
        tl.to(titles[prev], { autoAlpha: 0, duration: 0.5 }, 0)
        tl.to(contents[prev], { autoAlpha: 0, duration: 0.5 }, 0)
        tl.to(center_img[prev], { scale: 0.7 }, 0.5)
        tl.to(sections[prev], { y: topLoc }, 0.5);
        $(bgs[prev]).removeClass('show');
      }
      $(sections[index]).show();
      tl.to(center_img[index], { scale: 1 }, 0.5);
      tl.to(sections[index], { y: midLoc, scale: 1 }, 0.5);
      tl.to(titles[index], { autoAlpha: 1, duration: 0.5 }, 1)
      tl.to(contents[index], { autoAlpha: 1, duration: 0.5, onComplete: () => { animating = false; } }, 1)
      $(bgs[index]).addClass('show');
      
      if (index < sections.length) {
        next = index + 1;
        $(sections[next]).show();
        tl.set(titles[next], { autoAlpha: 0 });
        tl.set(contents[next], { autoAlpha: 0 });
        tl.fromTo(sections[next], { y: startBotLoc }, { y: botLoc }, 0.5);
        tl.fromTo(center_img[next], { scale: 0.7 }, { scale: 0.7 }, 0.5);
      }
  }
  
  $(document).ready(function() {
      
      const ourHeroAnimate = gsap.timeline({
        scrollTrigger: {
  	      trigger: '.our_story_hero.paragraph--type--hero-centralized-content',
    			start: 'top-=1 top',
    			end: 'bottom top',
    			toggleActions: 'play none play reset',
    	  }
      });
      
      ourHeroAnimate
        .to('.background_image', { autoAlpha: 1, duration: 0.5 }, 0)
        .to('.our_story_hero .title', { autoAlpha: 1, duration: 0.8, ease: "power2.inOut"}, 0.5)
        .fromTo('.our_story_hero .content', { scale: 0.3, autoAlpha: 0 }, {autoAlpha: 1, scale: 1, duration: 1.5,}, 0.5)
              
      const ourDoubleTopAnimate = gsap.timeline({
        scrollTrigger: {
  	      trigger: '.our-story-double.paragraph--type--double-panel-content.double-top',
    			start: 'top+=20 bottom',
    			end: 'bottom bottom',
    			toggleActions: 'play none play reset',
    	  }
      });
      
      ourDoubleTopAnimate
              .fromTo('.double-top .left_container', { y: '100vh'}, { y: 0, duration: 0.8, ease: "sine.inOut"}, 0)
              .fromTo('.double-top .right_container', { y: '100vh'}, { y: 0, duration: 0.8, ease: "sine.inOut"}, 0)
              
      const ourDoubleBottomAnimate = gsap.timeline({
        scrollTrigger: {
  	      trigger: '.our-story-double.paragraph--type--double-panel-content.double-bottom',
    			start: 'top bottom',
    			end: 'bottom bottom',
    			toggleActions: 'play none play reset',
    	  }
      });
      
      ourDoubleBottomAnimate
              .fromTo('.double-bottom .left_container', { y: '100vh'}, { y: 0, duration: 0.8, ease: "sine.inOut"}, 0)
              .fromTo('.double-bottom .right_container', { y: '100vh'}, { y: 0, duration: 0.8, ease: "sine.inOut"}, 0)
      
      
      if ($(".story-simple").length) {
          const simpleAnimate = gsap.timeline({
            scrollTrigger: {
      	       trigger: '.paragraph--type--simple-section',
        			 start: 'top+=50 bottom',
        			 end: 'bottom bottom',
        			 toggleActions: 'play none play reset',
        	  }
          });
          
          simpleAnimate
                  .fromTo('.paragraph--type--simple-section .story-simple', { autoAlpha: 0}, { autoAlpha: 1, duration: 1, ease: "power2.inOut"}, 0)    
      }
      
      const simpleEndContainer = gsap.timeline({
        scrollTrigger: {
          trigger: '.simple-end-container',
    			start: 'top bottom',
    			end: 'bottom top',
    			toggleActions: 'play none play reset',
        }
      });
      
      simpleEndContainer.fromTo('.simple-end-container .simple-container', { autoAlpha: 0}, { autoAlpha: 1, duration: 1, ease: "power2.inOut"}, 0)    
  });
}